import { CNAVisitEncounterEVVStatus } from 'fhir/Encounter/constants'

export interface InterventionData {
  id: string
  name?: string
  text: string
  status: string
  statusReason: string
  note: string
}

export enum EncounterEVVType {
  SIGNATURE = 'signature',
  TIME = 'time',
  TASKS = 'tasks'
}

export type EVVChecks = Record<EncounterEVVType, CNAVisitEncounterEVVStatus | string>
